export default {
    apiKey: "AIzaSyD98vipu9eRSxtG8mCIj4M0r1SsgTJF9rI",
    authDomain: "basics-1f6a7.firebaseapp.com",
    databaseURL: "https://basics-1f6a7.firebaseio.com",
    projectId: "basics-1f6a7",
    storageBucket: "basics-1f6a7.appspot.com",
    messagingSenderId: "193643440315"
};


// WEBPACK FOOTER //
// ./src/fire.js